import type { SVGProps } from 'react';

const SvgShipping = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M25 10.84a.77.77 0 0 0-.53-.22h-3.95V5.29a2.79 2.79 0 0 0-2.79-2.79H3A2.79 2.79 0 0 0 .23 5.29v7A2.75 2.75 0 0 0 3 15.05h10.24l-3 3 1.06 1.06 4.34-4.33a.75.75 0 0 0 0-1.06L11.28 9.4l-1.06 1.06 3.09 3.09H3a1.25 1.25 0 0 1-1.27-1.25v-7A1.29 1.29 0 0 1 3 4h14.73A1.29 1.29 0 0 1 19 5.29V25.8h-8.39a3.88 3.88 0 0 0-7.61 0 1.29 1.29 0 0 1-1.27-1.3v-7H.23v7A2.79 2.79 0 0 0 3 27.29a3.88 3.88 0 0 0 7.61 0h11a3.88 3.88 0 0 0 7.62 0 2.79 2.79 0 0 0 2.55-2.77v-5.78a2.74 2.74 0 0 0-.81-1.95ZM6.81 28.93a2.39 2.39 0 1 1 2.38-2.38 2.38 2.38 0 0 1-2.38 2.38Zm17.33-16.81 5.09 5.09h-8.71v-5.09Zm1.24 16.81a2.39 2.39 0 1 1 2.38-2.38 2.38 2.38 0 0 1-2.38 2.38Zm4.86-4.43a1.29 1.29 0 0 1-1.06 1.25 3.88 3.88 0 0 0-7.61.05h-1.05v-7.09h9.71v5.79Z"
      data-name="smart-send-time"
    />
  </svg>
);

export default SvgShipping;
